

    document.addEventListener("DOMContentLoaded", function () {
      function selectFilter() {
        let findFilter = document.querySelectorAll('.filter-list');
        findFilter.forEach(filter => {
          let f = filter.querySelector('.js-collection-side-filter'); 
          if(f) {
            let label = f.querySelector('.regular-filter--label');
            if(label?.innerText.includes('lager')) {
              let input = f.querySelector('input');
              if(!input.checked) {
                f.click();
              }
          }
          }
        });
      }
      selectFilter();
    });
    


// CROSS SELL 



if(document.querySelector('body').classList.contains('template-product')) {
  const items = [];

  const tilvalg = document.querySelectorAll('.product-tilvalg');

  const totalprice = document.querySelector('.custom_subtotal');

  // CHANGE TOTAL ON QUANTITY CHANGE ON ORIGINAL PRODUCT;
  const currentProduct = document.querySelector('.ProductForm');
  let currentProductQuantity = 1;

  let originalPrice = parseInt(totalprice.dataset.price);


  document.querySelector('.qty-selection .quantity__wrapper').addEventListener('click', function(e) {

    let price = parseInt(totalprice.dataset.price);
    let action = e.target.dataset.action;

    switch(action) {
      case 'increase-quantity':

        currentProductQuantity += 1;
        
        console.log(price);
        price += originalPrice;

        totalprice.innerHTML = price;
        totalprice.dataset.price = price;

        break;
      case 'decrease-quantity':
  
        if(currentProductQuantity != 1) {
          price -= originalPrice;
          totalprice.innerHTML = price;
          totalprice.dataset.price = price;
          currentProductQuantity -= 1;
        }

        break;
      default:
        break;
    }
  });


  tilvalg.forEach((product) => { 


    // Listen to each product in list.
    product.addEventListener('click', function() {

      // Choose element that get the highlight-product class
      const prod = this.querySelector('.ProductItem__Wrapper');
      prod.classList.toggle('highlight-product');

      const id = parseInt(this.querySelector('.product_id').dataset.id);
      const price =  parseInt(this.querySelector('.product_price').dataset.price);
      let total = parseInt(totalprice.dataset.price);

      if(prod.classList.contains('highlight-product')) {

        
        
        const quantity = 1;
        // we only need ID and Quantity(1);
        const item = {
          'id': id,
          'quantity': quantity,
        };
  
        items.push(item);


        // GET PRICE
        total +=  price;

        totalprice.dataset.price = total;
        totalprice.innerHTML = total;


      } else {

        index = items.findIndex(element => element.id === id);
        
        items.splice(index, 1);


        total = total - price;
        totalprice.dataset.price = total;
        totalprice.innerHTML = total;
      
      }

    
    });
  });


  // Get the button


  jQuery('.product__add-button').click(function(){    

    // let currentProductID = parseInt(currentProduct.querySelector('input[name="id"]').value);
    // let currentProductItem = {
    //   'id': currentProductID,
    //   'quantity': currentProductQuantity,
    // };

    // if(items.some(item => item.id === currentProductItem.id)){
  
    // } else{
    //   items.push(currentProductItem);
    // }

    

    let formData = {
      'items': items,
      };

      console.log(formData);

      setTimeout(() => {
      AddAllItemsToCart(formData);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true 
      }));

      document.querySelectorAll('.product-tilvalg').forEach((product) => { 
        product.querySelector('.ProductItem__Wrapper').classList.remove('highlight-product');
      });
      items.length = 0;
      totalprice.dataset.price = currentProductQuantity * originalPrice;
      totalprice.innerHTML = currentProductQuantity * originalPrice;

      }, 250);

    
  });
  
}

function AddAllItemsToCart(tilvalg) {
  data = tilvalg;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true 
      }));
    }   

  }); 
}


if(document.querySelector('body').classList.contains('collection__template--container')) {
  jQuery(document).ready(function () {


  jQuery('.js-modal-overlay, .js-modal-close').on('click', function(e) {
        
        e.preventDefault();
        jQuery('.modal iframe').attr('src', '');

    });
  

    if (jQuery('.product-index .collection-image').hasClass('empty_collection')) {

      jQuery('.product-index .empty_collection').parent().addClass('removeEmptyCol');
    };
  });
};

